<template>
  <div class="gray-back kaoji-box" style="padding:.2rem 0 1rem 0 ;  height: 100%">

    <van-cell-group>
      <van-cell title="单位名称" :value="row.danwei"></van-cell>
      <van-cell title="所属区域" :value="areaValue"></van-cell>
      <van-cell title="先进个人" :value="row.name"></van-cell>
      <van-cell title="证书编号" :value="row.bcode ? row.bcode : '无'"></van-cell>
      <van-cell title="先进单位电子授权书" ></van-cell>
      <div class="bottom-img" v-show="!isLoading">
        <img :src="row.danwei_pic" alt="">

        <van-button  v-if="!isApp" style="margin: 10px auto; text-align: center " type="default" round>请长按图片保存</van-button>
        <van-button v-else @click="onPrint" style="margin: 10px auto; text-align: center " type="default" round>点击下载证书</van-button>
      </div>
      <van-cell title="先进个人电子授权书" ></van-cell>
      <div class="bottom-img" v-show="!isLoading">
        <img :src="row.person_pic" alt="">

        <van-button  v-if="!isApp" style="margin: 10px auto; text-align: center " type="default" round>请长按图片保存</van-button>
        <van-button v-else @click="onPrintPerson" style="margin: 10px auto; text-align: center " type="default" round>点击下载证书</van-button>
      </div>
      <div style="height: 10px"></div>

    </van-cell-group>

    <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel"/>
  </div>
</template>
<style scoped>
.kaoji-box .van-cell__value {
  color: #323233;
}
.kaoji-title {
  padding: .3rem;
  font-size: 24px;
  text-align: center;
}

.kaoji-mine {
  padding: 0 .3rem .4rem;
}

.bottom-img {
  text-align: center;
  margin-top: .3rem;
}

.bottom-img img {
  width: 100%;
}

.bottom-button {
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}


.van-tag {
  margin-right: 10px;
  text-align: center;
}

.between {
  justify-content: space-between;
}


</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';
import LoginDialog from '@/components/LoginDialog.vue';

import {
  Cell,
  Field,
  Dialog,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button
} from 'vant';

Vue.use(Cell).use(CellGroup).use(Dialog).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button);
export default {
  name: 'CDakejianDetail',
  components: {
    PicUploader,
    LoginDialog
  },
  data: function () {
    return {
      validator,
      loginShow: false,
      saveLoading: false,
      isLoading: true,
      showArea: false,
      areaList: {},
      areaValue: '',
      submitType: '',
      id: 0,
      row: {},
      isApp: window.isApp()
    }
  },
  filters: {},
  mounted() {
    let that = this;
    that.id = this.$route.query.id;
    document.title = "乡村振兴公益活动详情"
    that.fetch();

  },
  watch: {},
  destroyed() {
  },
  methods: {
    onQuestion() {
      console.log('onQuestion')
    },
    fetch() {
      let that = this;
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
      });
      that.$api.post('/api/crural/ruralDetail', {
        id : that.id,
      }, (res) => {
        that.areaValue = res.data.province + ' ' + res.data.city + ' ' + res.data.county
        that.row = res.data;

        that.isLoading = false
        Toast.clear()
      }, (res) => {
//                    Toast.fail(res.msg);
      })
    },

    // 打印电子授权书
    onPrint() {
      let that = this;
      // console.log('downloadPic');
      appEvent({
        name: 'downloadPic',
        query: {
          filename: that.row.danwei + '推广实施单位电子授权书',
          url:that.row.danwei_pic,
        }
      });
    },
    onPrintPerson() {
      let that = this;
      // console.log('downloadPic');
      appEvent({
        name: 'downloadPic',
        query: {
          filename: that.row.danwei + '先进个人电子授权书',
          url:that.row.person_pic,
        }
      });
    },
    loginSuccess(res) {
      console.log('-------登录成功--------', res);
      this.loginShow = false;
      this.fetch();
    },

    loginCancel() {
      console.log('-------取消登录--------');
      // this.loginShow = false;
    },

  }
}
</script>



// WEBPACK FOOTER //
// RuralDetail.vue?2b6f44f5